import { createContext } from 'use-context-selector';
import { getDefaultLanguage } from '../translations/translationProvider';
export const UserContext = createContext({ lang: getDefaultLanguage() });
